module.exports = __webpack_public_path__ + "img/31.4306011d.png";